"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (digits) {
    return Math.pow(10, -digits);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/number/digitsToPips.js
// module id = 102
// module chunks = 0